/* Decorative draft-only enhancement. Never classifies controls or product cards. */
(function () {
  function decorate() {
    if (!document.documentElement.hasAttribute('data-bsc-palette')) return;
    if (!document.body.classList.contains('template-index')) return; // homepage only (26 Sep 2026)
    var main = document.querySelector('main');
    if (!main) return;
    main.querySelectorAll('section, .shopify-section, [class$="__container"]').forEach(function (el) {
      if (el.hasAttribute('data-bsc-snow-surface') || el.closest('form, dialog, .hero')) return;
      var style = getComputedStyle(el);
      var rgba = style.backgroundColor.match(/[\d.]+/g);
      if (style.backgroundImage === 'none' && rgba && rgba.length >= 3 &&
          rgba.slice(0, 3).every(function (n) { return Number(n) >= 250; }) &&
          (rgba.length === 3 || Number(rgba[3]) === 1)) {
        el.setAttribute('data-bsc-snow-surface', '');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate);
  else decorate();
  document.addEventListener('shopify:section:load', decorate);
})();
